import { toAbsoluteUrl } from "./toAbsoluteUrl";

export function buildServiceSchema(service) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    serviceType: service.name,
    name: service.name,
    description: service.description,
    image: toAbsoluteUrl(service.image),
    provider: {
      "@type": "LocalBusiness",
      name: "Clear Choice Cleaning Services",
    },
    areaServed: "Melbourne, Australia",
  };
}

export function buildFaqSchema(faq = []) {
  if (!faq || faq.length === 0) return null;

  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faq.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.a,
      },
    })),
  };
}
